
    import { Component, Vue, Prop } from 'vue-facing-decorator';
    import GradientLegend from '@/components/main/GradientLegend.vue';

    // Legend for the selected area-set layer. The map colors areas on a normalized
    // density scale (light = low on the left, dark = high on the right); density has no
    // real-world unit so the ends are labelled Low / High rather than with numeric values.
    @Component({
        components: {
            GradientLegend,
        },
    })
    export default class AreaLegend extends Vue {
        @Prop({ default: null }) public data: any;
    }
